import Header from ".././header/index";
import DaligatorsDashboardSidebar from "./delegator_dashboard";
import SidebarHeading from "./sidebar_heading";
import Footer from '.././footer/index';



function ValigatorsDaligators() {
    document.title="Validators-Daligators - Decentralized finance with Secure & Scalable Blockchain Network"
    return (
        <div>
            <div className="main-page-wrapper">
            <Header/>
            <DaligatorsDashboardSidebar/>
            <SidebarHeading/>
            <Footer />     
     
            </div>


        </div>
    );
}
export default ValigatorsDaligators;